import { mapState, mapGetters } from 'vuex';
import moment from 'moment';

import orderStatusMixin from './orderStatusMixin';
import formatterMixin from './formatterMixin';

const orderMixin = {
  mixins: [orderStatusMixin, formatterMixin],
  computed: {
    ...mapState({
      states: (state) => state.general.states,
      vendorCatalogs: (state) => state.customerDetail.vendorCatalogs,
      orderTableOptions: (state) => state.order.orderTableOptions,
      newOrder: (state) => state.order.newOrder,
      nAddress: (state) => state.order.nAddress,
      showActionModal: (state) => state.order.showActionModal,
      actionModalView: (state) => state.order.actionModalView,
      loading: (state) => state.order.loading,
      processingOrder: (state) => state.order.processingOrder,
      activeTab: (state) => state.order.activeTab,
      allActiveCustomers: (state) => state.order.allActiveCustomers,
      allProducts: (state) => state.order.allProducts,
      allDiscountCodes: (state) => state.order.allDiscountCodes,
      selectedOrders: (state) => state.order.selectedOrders,
      activeOrderStatus: (state) => state.order.activeOrderStatus,
      orderRange: (state) => state.order.orderRange,
      selectedCorporation: (state) => state.order.selectedCorporation,
      partnerCorporation: (state) => state.order.partnerCorporation,
      orderFilters: (state) => state.order.orderFilters,
      smacOrderFilters: (state) => state.order.smacOrderFilters,
      memberOrdersHeaders: (state) => state.order.memberOrdersHeaders,
      sortedCorporation: (state) => state.order.sortedCorporation,
      allBranches: (state) => state.admin.allBranches,
      showRightSidebar: (state) => state.order.showRightSidebar,
      platformUsers: (state) => state.order.platformUsers,
      requestorId: (state) => state.order.requestorId,
      filterVendorCatalogs: (state) => state.order.filterVendorCatalogs,
      allHWSkus: (state) => state.order.allHWSkus,
      isPilot: (state) => state.order.isPilot,
      isOpen: (state) => state.order.isOpen,
      products: (state) => state.general.products,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'isManufactureAdmin',
      'orderTableHeaders',
      'orderTableData',
      'orderTableRecordCount',
      'subTotal',
      'taxTotal',
      'netTotal',
      'orderFilters',
      'shippingTotal',
    ]),
    selectedDate: {
      get() {
        return this.orderRange;
      },
      set(date) {
        this.changeOrderValue('orderRange', date);
      },
    },
  },
  methods: {
    changeOrderValue(field, value) {
      this.$store.dispatch('changeOrderValue', {
        field,
        value,
      });
    },
    changeNewOrderValue(field, value, filterInfo) {
      this.$store.dispatch('changeNewOrderValue', {
        field,
        value,
        filterInfo,
      });
    },
    toggleActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('changeOrderValues', [{
          field: 'showActionModal',
          value: false,
        }, {
          field: 'newOrder',
          value: {},
        }, {
          field: 'requestorId',
          value: '',
        }]);
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        this.$store.dispatch('changeOrderValues', changes);
      }
    },
    async changeOrderActiveTab(tab) {
      const { orderFilters } = this.$store.getters;
      await this.$store.dispatch('changeOrderActiveTab', {
        tab,
      });
      if (tab === 'partner') {
        this.$store.dispatch('filterOrdersPartner', {
          filters: orderFilters,
          showAllOrder: true,
        });
      } else {
        this.$store.dispatch('getAllCustomerOrders', {
          filters: orderFilters,
        });
      }
    },
    unselectDate() {
      this.$store.dispatch(
        'setOrderFilter',
        {
          field: 'orderRange',
          value: {
            start: null,
            end: null,
          },
        },
      );
    },
  },
  filters: {
    address(a) {
      if (a) {
        const {
          address1,
          city,
          state,
          zip,
        } = a;

        const add1 = address1.split(' ').join('-');

        return `${add1}, ${city}, ${state} ${zip}`;
      }
      return '--';
    },
    date(date) {
      if (date) {
        return moment(date).format('M-DD-YY');
      }
      return '--';
    },
    filterInfo(number) {
      if (number) {
        return number;
      }
      return '--';
    },
  },
};

export default orderMixin;
